module.exports = __webpack_public_path__ + "img/bg20.dab08842.png";